<template lang="pug">
div(:class="{ 'myanmar-login': myanmarLogin }")
  .bg-login(data-id="login-cover-image")
    .page-container.modal-dialog-centered.mx-auto.my-0(style="max-width: 500px;padding: 0 8px;")
      .login.login-v2.w-100.mx-auto(data-pageload-addclass='animated fadeIn')
        .user-wrap
          i.fas.fa-user
        .login-header
          .brand.text-yellow.text-center.text-uppercase
            b {{ $t("ui.combine.reset_password") }}
        .login-content
          b-form.margin-bottom-0(@submit.stop.prevent="submit" novalidate :disabled="!submission.success")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  :type=" (isOPWShown) ? 'password' : 'text'"
                  ref="old_password"
                  :dirty="$v.old_password.$dirty"
                  :error="$v.old_password.$error"
                  :placeholder='$t("ui.old_password")'
                  v-model.trim.lazy="$v.old_password.$model"
                  :maxLength="$v.old_password.$params.maxLength.max"
                  :disabled="loading"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isOPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                    i.fa(:class=" (isOPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                ValidateResult(:value="$v.old_password" :name="$t('ui.old_password')")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  :type=" (isPWShown) ? 'password' : 'text'"
                  ref="new_password"
                  :dirty="$v.new_password.$dirty"
                  :error="$v.new_password.$error"
                  :placeholder='$t("ui.new_password")'
                  v-model.trim.lazy="$v.new_password.$model"
                  :maxLength="$v.new_password.$params.maxLength.max"
                  :disabled="loading"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isPWShown" style="border-top-right-radius: 0;border-bottom-right-radius: 0;")
                    i.fa(:class=" (isPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                  PasswordRules(:buttonStyle="'border-top-left-radius: 0;border-bottom-left-radius: 0;border-top-right-radius: 6px;border-bottom-right-radius: 6px;'")
                ValidateResult(:value="$v.new_password" :name="$t('ui.new_password')" :errors="newPasswordErrors")
              .pwstrength-progress.mt-2(v-if="new_password")
                .progress(style="position: relative")
                  .progress-bar(
                    role="progressbar"
                    :style="{ width: newPasswordStrength.score + '%', backgroundColor: newPasswordStrength.barColor }"
                    :aria-valuenow="newPasswordStrength.score"
                    aria-valuemin="0"
                    aria-valuemax="100"
                  )
                  span.progress-text(:style="{ color: newPasswordStrength.textColor || '#fff' }") {{ newPasswordStrength.strength }} ({{ newPasswordStrength.score }}/100)
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  :type=" (isCPWShown) ? 'password' : 'text'"
                  ref="confirm_password"
                  :dirty="$v.confirm_password.$dirty"
                  :error="$v.confirm_password.$error"
                  :placeholder='$t("ui.confirm_password")'
                  v-model.trim.lazy="$v.confirm_password.$model"
                  :disabled="loading"
                )
                .input-group-append(style="cursor: pointer;")
                  b-button.btn.btn-outline-secondary.btn-sm(:pressed.sync="isCPWShown" style="border-top-right-radius: 6px;border-bottom-right-radius: 6px;")
                    i.fa(:class=" (isCPWShown) ? 'icon-eye-open fa-eye' : 'icon-eye-close fa-eye-slash'")
                ValidateResult(:value="$v.confirm_password" :name="$t('ui.confirm_password')" :name2="$t('ui.new_password')")
            //- .form-group.m-b-20
            //-   DebounceInput(
            //-     required
            //-     type="text"
            //-     autocomplete="off"
            //-     v-model.trim.lazy="$v.security_tag.$model"
            //-     :placeholder='$t("ui.security_tag")'
            //-     :disabled="loading"
            //-     :dirty="$v.security_tag.$dirty"
            //-     :error="$v.security_tag.$error"
            //-     :maxLength="$v.security_tag.$params.maxLength.max"
            //-   )
            //-   ValidateResult(:value="$v.security_tag" :name="$t('ui.security_tag')")
            .form-group.m-b-20
              b-input-group.input-group-sm
                DebounceInput(
                  required
                  type="text"
                  ref="security_code"
                  autocomplete="off"
                  v-model.trim.lazy="$v.security_code.$model"
                  :placeholder='$t("ui.security_code")'
                  :disabled="loading"
                  :dirty="$v.security_code.$dirty"
                  :error="$v.security_code.$error"
                  :maxLength="$v.security_code.$params.maxLength.max"
                )
                .input-group-append(style="cursor: pointer;")
                  SecurityCodeRules
              ValidateResult(:value="$v.security_code" :name="$t('ui.security_code')" :errors="securityCodeErrors")
            .form-group.m-b-20
              DebounceInput(
                required
                type="text"
                autocomplete="off"
                v-model.trim.lazy="$v.confirm_security_code.$model"
                :placeholder='$t("ui.confirm_security_code")'
                :disabled="loading"
                :dirty="$v.confirm_security_code.$dirty"
                :error="$v.confirm_security_code.$error"
                )
              ValidateResult(:value="$v.confirm_security_code" :name="$t('ui.confirm_security_code')" :name2="$t('ui.security_code')")
            .form-group.m-b-20
              b-alert.text-center.animated.flash(:show="!submission.success" variant="danger") {{ submission.status }}
            .login-buttons
              SubmitButton.btn.btn-block.btn-lg(:loading="loading" icon="fa fa-times" :text="$t('ui.reset')" isModal=false type="button"  @click="clear()")
              SubmitButton.btn.btn-block.btn-lg(:loading="loading" icon="fa fa-save" :text="$t('ui.save')" isModal=false type="button" @click="resetPasswordPost()")
  b-modal#secondaryIdAcknowledge(
    ref="secondaryIdModal"
    :title="$t('ui.secondary_id_acknowledge_title')"
    centered
    no-close-on-backdrop
    no-close-on-esc
    hide-header-close
    :hide-footer="!secondaryIdAcknowledged"
    size="md"
    @shown="secondaryIdAcknowledged = false"
  )
    .text-center.px-2
      p.mb-3
        | {{ $t("ui.secondary_id_label") }}:
        strong.text-dark  {{ secondaryIdToShow }}
      .text-left.p-5.bg-light.rounded.mx-auto.reset-password-secondary-id-box.d-flex.align-items-center
        b-form-checkbox(v-model="secondaryIdAcknowledged" class="small mb-0")
          | {{ $t("message.secondary_id_acknowledge_checkbox") }}
    template(slot="modal-footer")
      .d-flex.justify-content-center.w-100
        b-button(variant="success" @click="$refs.secondaryIdModal.hide()") {{ $t("ui.close") }}
</template>

<script>
import config from "@/config";
import { required, minLength, maxLength, sameAs, helpers } from "vuelidate/lib/validators";
import SubmitButton from "@/library/SubmitButton";
import ValidateResult from "@/library/ValidateResult";
import DebounceInput from "@/library/DebounceInput";
import PasswordRules from "@/library/PasswordRules";
import SecurityCodeRules from "@/library/SecurityCodeRules";


export default {
  components: {
    SubmitButton,
    ValidateResult,
    DebounceInput,
    PasswordRules,
    SecurityCodeRules
  },
  data() {
    return {
      isOPWShown: true,
      isPWShown: true,
      isCPWShown: true,
      old_password: "",
      new_password: "",
      confirm_password: "",
      security_tag: "MS",
      security_code: "",
      confirm_security_code: "",
      newPasswordErrors: [],
      newPasswordStrength: { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" },
      securityCodeErrors: [],
      loading: false,
      submission: {
        success: true,
        status: ""
      },
      redirect: "/settings",
      secondaryIdToShow: "",
      secondaryIdAcknowledged: false
    }
  },
  validations: {
    old_password: {
      required,
      maxLength: maxLength(50)
    },
    new_password: {
      required,
      valid: function(value) {
        if (!helpers.req(value)) return true;
        return this.$helpers.validatePassword(value).isValid;
      },
      notSame: function(value) {
        return value != this.old_password;
      },
      // minLength: minLength(8),
      maxLength: maxLength(50)
    },
    confirm_password: {
      required,
      sameAs: sameAs('new_password')
    },
    // security_tag: {
    //   required,
    //   minLength: minLength(6),
    //   maxLength: maxLength(20)
    // },
    security_code: {
      required,
      valid: function(value) {
        if (!helpers.req(value)) return true;
        return this.$helpers.validateSecurityCode(value).isValid;
      },
      minLength: minLength(6),
      maxLength: maxLength(6)
    },
    confirm_security_code: {
      required,
      sameAs: sameAs("security_code")
    }
  },
  computed: {
    myanmarLogin() {
      return config.myanmarLogin;
    }
  },
  watch: {
    new_password(value) {
      if (!value) {
        this.newPasswordErrors = [];
        this.newPasswordStrength = { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" };
        return;
      }
      const result = this.$helpers.validatePassword(value);
      this.newPasswordErrors = result.errors;
      const strengthStyles = {
        Weak: { badgeClass: "text-danger", barColor: "#dc3545", textColor: "#fff" },
        Fair: { badgeClass: "text-warning", barColor: "#ffc107", textColor: "#212529" },
        Strong: { badgeClass: "text-primary", barColor: "#007bff", textColor: "#fff" },
        "Very Strong": { badgeClass: "text-success", barColor: "#28a745", textColor: "#fff" }
      };
      const style = strengthStyles[result.strength] || { badgeClass: "text-muted", barColor: "#6c757d", textColor: "#fff" };
      this.newPasswordStrength = {
        score: result.score,
        strength: result.strength,
        badgeClass: style.badgeClass,
        barColor: style.barColor,
        textColor: style.textColor
      };
    },
    security_code(value) {
      if (!value) {
        this.securityCodeErrors = [];
        return;
      }
      const result = this.$helpers.validateSecurityCode(value);
      this.securityCodeErrors = result.errors;
    }
  },
  mounted () {
    this.$refs.old_password.$el.focus();
    this.showSecondaryIdModalIfNeeded();
  },
  methods: {
    showSecondaryIdModalIfNeeded: function() {
      const account = this.$store.state.user.account;
      let secondaryOnly = true;
      if (account && (account.secondary_only === false || account.secondary_only === 0 || account.secondary_only === "0")) {
        secondaryOnly = false;
      }
      let secondaryId = "";
      if (account && account.secondary_id) {
        secondaryId = String(account.secondary_id).trim();
      }
      if (secondaryOnly) {
        return;
      }
      if (!secondaryId) {
        return;
      }
      this.secondaryIdToShow = secondaryId;
      this.$nextTick(() => {
        this.$refs.secondaryIdModal.show();
      });
    },
    reset: function() {
      this.$v.$reset()
      this.submission.success = true
      this.submission.status = ""
      this.newPasswordStrength = { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" };
      this.newPasswordErrors = [];
    },
    clear: function() {
      this.old_password = ""
      this.new_password = ""
      this.confirm_password = ""
      this.security_tag = ""
      this.security_code = ""
      this.confirm_security_code = ""
      this.newPasswordStrength = { score: 0, strength: "", badgeClass: "", barColor: "#6c757d", textColor: "#fff" };
      this.newPasswordErrors = [];
      this.$nextTick(() => {
        this.reset()
      });
    },
    resetPasswordPost: function() {
      this.reset()
      this.$v.$touch()
      if (!this.$v.$invalid) {
        this.loading = true
        this.$swal({
          title: this.$t("ui.status"),
          text: this.$t("message.update_account_password_confirm"),
          type: "warning",
          showCancelButton: true,
          allowOutsideClick: false
        }).then(result => {
          if (result.value) {
            let password = this.old_password
            let new_password = this.new_password
            let security_tag = this.security_tag
            let security_code = this.security_code
            this.$store
              .dispatch("user/resetPasswordPost", { password, new_password, security_tag, security_code })
              .then(response => {
                this.loading = false
                this.submission.success = response.success
                this.$swal({
                  title: this.$t("ui.succeed"),
                  text: this.$t("message.update_account_password_success1"),
                  type: "success",
                  allowOutsideClick: false
                }).then(isConfirm => {
                  if (isConfirm) {
                    //this.cancel();
                    //redirect to login page
                    this.$router.push("/login")
                    // this.$router.push("/settings")
                  }
                });
              })
              .catch(response => {
                this.loading = false
                this.submission.success = false
                this.submission.status = this.$helpers.getErrorMessage(
                  response && response.errorTag,
                  "update_password_failed"
                );
              });
          } else if (
            // Read more about handling dismissals
            result.dismiss === 'cancel'
          ) {
            this.loading = false
            this.$swal({
              title: this.$t("ui.cancel"),
              text: this.$t("message.update_account_password_cancel"),
              type: "error",
              allowOutsideClick: false
            }).then(isConfirm => {
              if (isConfirm) {
                this.cancel();
              }
            });
          }
        });
      }
    },
    cancel: function() {
      this.clear()
      this.$router.push("/")
    }
  }
}
</script>
<style lang="scss" scoped>
.progress-text {
  position: absolute;
  left: 0;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  text-align: center;
  font-size: 0.75rem;
  font-weight: 600;
  pointer-events: none;
}
.reset-password-secondary-id-box {
  max-width: 360px;
  ::v-deep .custom-control-label::before,
  ::v-deep .custom-control-label::after {
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>